var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoPintura(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "67px",
    viewBox: "0 0 65 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pintura_65") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pintura_65",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.25,28.1666667 C55.25,29.3633296 54.2798144,30.3333333 53.0829271,30.3333333 C51.8868523,30.3333333 50.9166667,29.3633296 50.9166667,28.1666667 C50.9166667,26.9700037 51.8868523,26 53.0829271,26 C54.2798144,26 55.25,26.9700037 55.25,28.1666667",
    id: "Fill-1",
    fill: "#00A9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5833333,24.9166667 C59.5833333,26.1133296 58.6131477,27.0833333 57.4162604,27.0833333 C56.2201856,27.0833333 55.25,26.1133296 55.25,24.9166667 C55.25,23.7200037 56.2201856,22.75 57.4162604,22.75 C58.6131477,22.75 59.5833333,23.7200037 59.5833333,24.9166667",
    id: "Fill-1-Copy",
    fill: "#00A9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9166667,21.6666667 C63.9166667,22.8633296 62.946481,23.8333333 61.7495937,23.8333333 C60.553519,23.8333333 59.5833333,22.8633296 59.5833333,21.6666667 C59.5833333,20.4700037 60.553519,19.5 61.7495937,19.5 C62.946481,19.5 63.9166667,20.4700037 63.9166667,21.6666667",
    id: "Fill-1-Copy-4",
    fill: "#00A9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5833333,31.4166667 C59.5833333,32.6133296 58.6131477,33.5833333 57.4162604,33.5833333 C56.2201856,33.5833333 55.25,32.6133296 55.25,31.4166667 C55.25,30.2200037 56.2201856,29.25 57.4162604,29.25 C58.6131477,29.25 59.5833333,30.2200037 59.5833333,31.4166667",
    id: "Fill-1-Copy-3",
    fill: "#00A9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9166667,34.6666667 C63.9166667,35.8633296 62.946481,36.8333333 61.7495937,36.8333333 C60.553519,36.8333333 59.5833333,35.8633296 59.5833333,34.6666667 C59.5833333,33.4700037 60.553519,32.5 61.7495937,32.5 C62.946481,32.5 63.9166667,33.4700037 63.9166667,34.6666667",
    id: "Fill-1-Copy-5",
    fill: "#00A9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9166667,28.1666667 C63.9166667,29.3633296 62.946481,30.3333333 61.7495937,30.3333333 C60.553519,30.3333333 59.5833333,29.3633296 59.5833333,28.1666667 C59.5833333,26.9700037 60.553519,26 61.7495937,26 C62.946481,26 63.9166667,26.9700037 63.9166667,28.1666667",
    id: "Fill-1-Copy-2",
    fill: "#00A9FD"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    stroke: "#00A9FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "5.41666667 34.6666667 45.5 34.6666667 45.5 21.6666667 5.41666667 21.6666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-15",
    stroke: "#00A9FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0 32.5 5.41666667 32.5 5.41666667 23.8333333 0 23.8333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0833333,0 L14.0833333,10.6863655 C14.0833333,14.2648896 16.9848394,17.1663956 20.5633635,17.1663956 C24.1418876,17.1663956 27.0433936,14.2648896 27.0433936,10.6863655 L27.0433936,0 L14.0833333,0 Z",
    id: "Stroke-16",
    stroke: "#00A9FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-17",
    stroke: "#00A9FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "15.4761905 53.0833333 5.41666667 53.0833333 11.6079678 34.6666667 21.6666667 34.6666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94578313,53.8273092 C9.94578313,59.8865361 14.8571335,64.7978865 20.9163604,64.7978865 L45.1231175,64.7978865",
    id: "Stroke-18",
    stroke: "#00A9FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7399598,17.3333333 L20.7399598,21.6282279",
    id: "Stroke-19",
    stroke: "#00A9FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9166667,21.6666667 L37.9166667,34.6666667",
    id: "Stroke-20",
    stroke: "#00A9FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-21",
    stroke: "#00A9FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "19.5130522 43.8293173 29.4542287 43.8293173 32.5130522 35.1626506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,28.1666667 L48.75,28.1666667",
    id: "Stroke-22",
    stroke: "#00A9FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPintura);
export default __webpack_public_path__ + "static/media/PictoPintura.9c635885c7ac36860958b0f985b84b58.svg";
export { ForwardRef as ReactComponent };